import { render, staticRenderFns } from "./EventsSelector.vue?vue&type=template&id=61542bf4&"
import script from "./EventsSelector.vue?vue&type=script&lang=js&"
export * from "./EventsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports